import { Link } from 'react-router-dom';
import {
  ComponentSettingsPropertiesModel,
  LinkItemElementContentModel,
  LinkItemPropertiesModel,
  LinksNavigationElementContentModel,
  LinksNavigationPropertiesModel,
} from '@/services/platform/api/model';
import { cn, LinksToLinkMap, ModuleProperties } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { Icon } from '@/components/ui/icon';
import { useApp } from '@/lib/core/providers/appProvider';

export const LinksNavigation = (props: ModuleProperties) => {
  const { user } = useApp();
  const content = props.content as LinksNavigationElementContentModel | undefined;

  if (!content) return null;

  const properties = content.properties as LinksNavigationPropertiesModel;
  const hasActiveMembership = user?.hasActiveMembership ?? false;

  const navigation = properties?.links?.items
    ?.filter(i => !(i.settings?.properties as ComponentSettingsPropertiesModel)?.hide)
    ?.filter(
      i =>
        !(i.content?.properties as LinkItemPropertiesModel)?.membersOnly ||
        ((i.content?.properties as LinkItemPropertiesModel)?.membersOnly && hasActiveMembership)
    )
    .map(i => i.content as LinkItemElementContentModel);

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__links-navigation']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      <div className="flex flex-1 flex-col px-4 py-6">
        {navigation?.map((item, index) => {
          const link = LinksToLinkMap(item?.properties?.link ?? undefined);
          const linkLabel = link?.label;
          const linkHref = link?.href;

          if (linkHref && linkLabel) {
            return (
              <Link
                key={index}
                to={linkHref}
                className="border-jncquoi-neutral-900 flex w-full items-center justify-between border-b-[0.5px] py-2.5 first:border-t-[0.5px]"
                aria-label={linkLabel}
                target={link?.target}
              >
                <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 min-w-0 flex-1 text-left text-[12px] tracking-[0.5px] uppercase">
                  {linkLabel}
                </span>
                <div className="flex size-11 shrink-0 items-center justify-center">
                  <Icon name="nav-arrow-right" width={20} height={20} className="text-jncquoi-neutral-1000" />
                </div>
              </Link>
            );
          }
        })}
      </div>
    </ModuleWrapper>
  );
};
